// extracted by mini-css-extract-plugin
export var categoryIcon = "XWS3i";
export var compact = "xFMKk";
export var compactTypeRamp = "K8aq2";
export var full = "Cnnoo";
export var fullTypeRamp = "NVKyM";
export var groupHeaderAction = "d4ROo";
export var groupHeaderActionInProgress = "EV9d6";
export var groupHeaderClickable = "MtAK6";
export var groupHeaderFocusOutline = "qvgmu";
export var iconContainer = "H1SeE";
export var innerTextContainer = "PukTV";
export var mcl = "uX_WS";
export var mclMoreButton = "gDrGb";
export var medium = "yNQ4B";
export var mediumTypeRamp = "UhEwu";
export var moreButton = "jUsDj";
export var moreIcon = "vQXSg";
export var noCheckboxStyles = "isChz";
export var outerContainer = "HJne5";
export var outerContainerBleedthrough = "f95EZ";
export var outerContainerWithActions = "l17f5";
export var scl = "pqyEZ";
export var sclMoreButton = "c58By";
export var selectionModeActivated = "Chrlg";
export var senderImageOn = "lzRkn";
export var spinner = "PdYz8";